import type { Group } from "building-types/groups/group";
import type { PropAttributes } from "building-types/props/propTypes";
import type { RWTable, Table } from "common/data/table";
import { docEntityHandleHash } from "../../entity/core/handleHash";
import { defaultExteriorPropCatalog } from "./exteriorPropCatalog";
import { defaultInteriorPropCatalog } from "./interiorPropCatalog";

export const builtInPropAttributes: Table<PropAttributes> = {
  ...defaultInteriorPropCatalog,
  ...defaultExteriorPropCatalog,
};
export const builtInPropsGroupId = "builtInPropsGroup";

export const builtInPropsEntityGroups: Table<Group["id"]> = Object.keys(builtInPropAttributes).reduce(
  (acc, propId) => {
    acc[docEntityHandleHash({ type: "PROP", id: propId })] = builtInPropsGroupId;
    return acc;
  },
  {} as RWTable<Group["id"]>,
);
